import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/Button';

const SearchAI = () => {
  // Removed duplicate navigate declaration
  const { state } = useLocation(); // API response passed via navigation

  const handleSelect = (category, reason) => {
    navigate('/search-map', { state: { category, reason } });
  };

  const handleFindManual = () => {
    navigate('/search-manual');
  };

  const data = state?.data || {};
  const category1 = data.resultCategory1;
  const reason1 = data.resultReason1;
  const category2 = data.resultCategory2;
  const reason2 = data.resultReason2;
  const noResult = !category1 || category1 === 'Unknown';

  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex flex-1 justify-center bg-gray-50 py-12">
        <div className="w-full max-w-2xl px-4">
          <div className="text-center pt-12">
            {noResult && (
              <div className="pt-16 pb-4">
                <h2 className="text-3xl font-bold mb-2">No applicable field of law found</h2>
                <p className="mt-4 text-lg text-gray-600">
                  We were unable to reasonably determine an applicable field of law for your request. Please try again or select one manually.
                </p>
              </div>
            )}
            {!noResult && (
              <>
                <h2 className="text-3xl font-bold">We've found some potential practice areas for you</h2>
                <p className="mt-4 text-lg text-gray-600">
                  Our AI has analyzed your search query and suggests the following areas of law.
                </p>
              </>
            )}
          </div>
          <div className="mt-10 space-y-6">
            {!noResult && (
              <div className="flex flex-col md:flex-row items-stretch rounded-lg border bg-white shadow-sm">
                <div className="flex flex-col justify-between p-6 flex-1">
                  <div>
                    <p className="text-lg font-bold">{category1}</p>
                    <p className="mt-1 text-sm text-gray-500">{reason1}</p>
                  </div>
                  <Button onClick={() => handleSelect(category1, reason1)}>
                    Select
                  </Button>
                </div>
              </div>
            )}
            {!noResult && category2 && category2 !== 'Unknown' && (
              <div className="flex flex-col md:flex-row items-stretch rounded-lg border bg-white shadow-sm">
                <div className="flex flex-col justify-between p-6 flex-1">
                  <div>
                    <p className="text-lg font-bold">{category2}</p>
                    <p className="mt-1 text-sm text-gray-500">{reason2}</p>
                  </div>
                  <Button onClick={() => handleSelect(category2, reason2)}>
                    Select
                  </Button>
                </div>
              </div>
            )}
          </div>
          <div className="mt-8 border-t pt-8 text-center">
            <Button variant="outline" className="mt-4 w-full" onClick={handleFindManual}>
              Find Manually
            </Button>
            <Button
              type="button"
              className="mt-4 w-full bg-gray-100 text-gray-800 hover:bg-gray-200 font-bold py-3 rounded-md border border-gray-300"
              onClick={() => navigate(-1)}
            >
              <span className="material-symbols-outlined align-middle mr-2">arrow_back</span>
              Back
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SearchAI;
